export default "__VITE_ASSET__93042b0c__"